import { History } from 'history';

import { CallActionPayload, MethodResponse } from '../../types';

export const navigate = async (
  payload: CallActionPayload,
  history: History
): Promise<MethodResponse | void> => {
  const { url } = payload as { url: string };

  history.push(url);

  const hashIndex = url.indexOf('#');
  if (hashIndex !== -1) {
    const hash = url.substring(hashIndex + 1);

    // Try multiple times with increasing delays to handle page loading
    const attemptScroll = (attempt: number) => {
      const element = document.getElementById(hash);
      if (element) {
        // Get element position and scroll with offset for nav bar
        const elementRect = element.getBoundingClientRect();
        const offsetTop = window.pageYOffset + elementRect.top - 200;

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      } else if (attempt < 3) {
        setTimeout(() => attemptScroll(attempt + 1), 200 * attempt);
      }
    };

    setTimeout(() => attemptScroll(1), 100);
  }

  return Promise.resolve();
};
